







































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import { localGet, timeFormat, jsIntString } from "@/utils/index";
import SupplierJson from "@/doc/Supplier.json"; //  lee 自己存储的供应商json
import { pagnition } from "@/utils/commonConfig";
import { VerifyActionStatus } from "@/enum/tel";
@Component({
  name: "ExamineDetail",
  components: {},
})
export default class ExamineDetail extends Vue {
  @Provide() private imgHeight: string = "80%";
  @Provide() private phoneObject: any = []; // 电话对象
  @Provide() private callLogData: any = []; // 通话记录list
  @Provide() private dialogTableVisible: boolean = false; // 通话记录弹窗
  @Provide() private dialogImageVisible: boolean = false; // 图片放大旋转弹窗
  @Provide() private saveRecordLoading: boolean = false; // 审核完成loading
  @Provide() private saveQiRecordLoading: boolean = false; // 质检提交loading
  @Provide() private idphotosourceswitch: boolean = false; // 证件照来源
  @Provide() private isShowPhoneCon: boolean = false; // 是否显示电话审核相关：当含有2类问题时显示，即 qptype = 3
  @Provide() private imgUrl: string = ""; // 图片放大旋转地址
  @Provide() private imgStyle: string = "width:"; // 图片放大旋转样式
  @Provide() private audioSrcNext: any = ""; // 录音文件src属性
  @Provide() private qlRemark: string = ""; // 质检备注
  @Provide() private phonestatusMap: any = []; // 质检备注
  @Provide() private tickettags: any = []; // 工单标签

  // 保存通话参数
  @Provide() private formSaveCall:any = {
    result: "",
    remark: "",
    phoneConnected: "",
    phoneObject: "",
    phoneCallInput: "",
    phoneTime: "",
    callId: "",
    phoneCallNX: "",
  };
  @Provide() private qistatus:any = null;
  @Provide() private pvCallingSwitch:boolean = false;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private changePageCount: any = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private dialogImgVisible: boolean = false;
  @Provide() private dealDisabled: boolean = true; // 是否禁用稍后处理
  @Provide() private finishedDisabled: boolean = true; // 是否禁用审核完成
  @Provide() private pvInfo: any = {}; // 人工审核-是否展示开关
  @Provide() private flagLoading: boolean = true; // 
  @Provide() private radioList: Array<Object> = [
    { label: "ticket.normal", value: 1 },
    { label: "ticket.abnormal", value: 0 },
  ]; // 人工审核-radioList
  @Provide() private uesrInfo: any = {}; // 用户消息
  @Provide() private questionList: any = []; // 问题库
  @Provide() private status: number | string = 2; // 审核状态 1 审核中，2 通过，3 失效，4 拒绝
  @Provide() private addAnswers: any = []; // 提交审核-问题回答
  // @Provide() private A9answerList: any = []; //默认选项
  @Provide() private answersList: any = []; // 审核结果查询-问题回答
  @Provide() private nxteleValue: any = [];
  @Provide() private remark: string = ""; // 备注
  @Provide() private pvstatus:number|string = 0; // 审核状态
  @Provide() private supplierOptions: any[] = SupplierJson.list; // 匹配供应商映射list
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private providerOptions: any[] = []; // 匹配供应商映射list
  @Provide() private itemId: any = "";
  @Provide() private phoneobjectmobilesaltMap: any = [];
  @Provide() private suppliertypeList: any = [];
  @Provide() private isActived: any = "";
  @Provide() private activedStatus: any = "";
  @Provide() private idCardPhotoList: any = []; //证件照片组
  @Provide() private livePhotoList: any = []; //活体照片组
  @Provide() private isshow: any = "";
  @Provide() private isAudi: any = "";
  @Provide() private pickerOptions = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    }
  }; // 可选中时间不能超过今天
  @Provide() private showBirth: boolean = false;
  @Provide() private showLoan: boolean = false;
  @Provide() private isReloan: number= 0;
  @Provide() private appname: any= '';
  private created() {
    this.getBirthStatus();
    this.getQuestion();
    this.$route.query.ticketitemid !== "101" && this.callLog();
    this.itemId = this.$route.query.ticketitemid; // PV 100 、IR 101、 QI 102
    this.isshow = this.$route.query.isshow;
    this.isAudi = this.$route.query.isAudi;
    this.appname = this.$route.query.appname;
  }
  private getSystemInfo() {
    // 获取 radio_switch ,true 为 展示开关， false 时展示下拉选择
    const info: any = JSON.parse(localStorage.getItem("systemInfoAll") || "");
    this.pvInfo = info?.pv?.radio_switch;
  }
  private callLogFuc(data: any) {
    data.map((item: any) => {
      item.phonetime = timeFormat(item.phonetime);
      this.$set(item, "play", true); // 设置播放状态
      this.$set(item, "videoLoading", false); // 录音文件loading 展示
      this.$set(item, "videoShow", false); //audio 展示
    })
    return data;
  }
  // 图片放大
  private showImage(index: any, n: any, type: number, list: string) {
    if (type === 0) {

      let item: any = this.questionList[index].associateditemsList[n];
      this.dialogImgVisible = true;
      item.showBig = true;
      item.height = 500;
      if (item.imagetype == 1) {
        this.livePhotoList[0].showBig = true;
        this.livePhotoList[0].height = 500;
      } else if (item.imagetype == 2) {
        this.idCardPhotoList[0].showBig = true;
        this.idCardPhotoList[0].height = 500;
      }
    } else if (type === 1) {
      index.height -= 50;
    } else if (type === 2) {
      index.height += 50;
    } else if (type === 3) {
      index.rotate -= 90;
    } else if (type === 4) {
      index.rotate += 90;
    } else if (type === 5) {
      this.dialogImgVisible = false;
      this.idCardPhotoList.forEach((x: any) => {
        x.showBig = false;
        x.height = 0;
        x.rotate = 0;
      });
      this.livePhotoList.forEach((q: any) => {
        q.showBig = false;
        q.height = 0;
        q.rotate = 0;
      });
    } else if (type === 6) {
      if (n !== 0) {
        index.showBig = false;
        if (list == "id") {
          this.idCardPhotoList[n - 1].showBig = true;
          this.idCardPhotoList[n - 1].height = 500;
        } else {
          this.livePhotoList[n - 1].showBig = true;
          this.livePhotoList[n - 1].height = 500;
        }
      }
    } else if (type === 7) {
      if (list == "id") {
        if (n < this.idCardPhotoList.length - 1) {
          index.showBig = false;
          this.idCardPhotoList[n + 1].showBig = true;
          this.idCardPhotoList[n + 1].height = 500;
        }
      } else {
        if (n < this.livePhotoList.length - 1) {
          index.showBig = false;
          this.livePhotoList[n + 1].showBig = true;
          this.livePhotoList[n + 1].height = 500;
        }
      }
    }
  }
  private getBirthStatus() {
    const country = localStorage.getItem("country");
    this.showBirth = country === "en" || country === "id" || false;
    this.showLoan = country === "id" || false;
  }
  // 查询通话记录
  private async callLog(){
    let _arg:any = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      ticketItemId: this.$route.query.ticketitemid,
      orderId: this.$route.query.orderid,
      ticketId: this.$route.query.ticketid
    }
    const { ListCall }: any = await import("@/request/examineDetail");
    let res = await ListCall(
      _arg,
      this
    );
    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      if (_result) {
        this.callLogData = this.callLogFuc(_result);
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  // lee 获取录音文件
  private async getFileInfoV2(e: any, row: any, index: number) {
    row.videoLoading = true;
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: jsIntString(row.callid) ? row.callid : null,
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      row.videoLoading = false;
      row.videoShow = true;

      this.audioSrcNext =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.callLog();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.callLog();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.callLog();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.callLog();
  }
  // 匹配催收方式
  private matchProviderOptions() {
    this.supplierOptions.forEach((item: any) => {
      this.suppliertypeList.forEach((s: any) => {
        if (item.id == s) {
          this.providerOptions.push(item);
        }
      });
    });
      }
  // 拨打对象选择
  private phoneObjectChange(value: any) {
    this.phoneObject.map((item: any) => {
      if (item.value == value[0]) {
        this.formSaveCall.phoneCallInput = item.phone;
      }
    });
    this.phoneobjectmobilesaltMap.map((item: any) => {
      if (item[0] == value[0]) {
        this.formSaveCall.phoneCallNX = item[1];
      }
    });
  }
  // 复制成功
  private onCopy(e: any) {
    this.$message.success("copy success");
  }
  // 复制失败
  private onError(e: any) {
    this.$message.success("copy failed");
  }
  // 重置下拉框可点击
  private selectDisable(disabled: boolean) {
    this.questionList.map((n: any, index: number) => {
      n.disabledfirst = disabled;
      this.$set(this.questionList, index, n);
    });
  }
  // 下拉框更改
  private selectChange(
    questionId: string,
    optionId: string | number,
    options: any,
    flag: any
  ) {
 
    // 点击清空select时 重置下拉框可点击
    if (optionId === "") {
      this.selectDisable(false);
    }
    // 当optionId: 0 为异常单选按钮
    // 取出当前问题
    if (optionId === 0) {
      const itemIndex = this.questionList.findIndex(
        (qL: any) => qL.id === questionId
      );
      optionId = itemIndex !== -1 ? this.nxteleValue[itemIndex] : optionId;
    }
    // 获取当前下拉款选中action，选中者拒绝时将其他下拉框置为不可点击，否则全部可点击
    options.map((item: any) => {
      if (item.index == optionId || optionId === 0) {
        if (item.action == 3 || item.action == 2) {
          this.status = "3";
          this.questionList.map((m: any, index: number) => {
            this.nxteleValue[index] =
              this.nxteleValue[index] == "0"
                ? this.$tc("dashbordDy.nochoosed")
                : this.nxteleValue[index];
            if (m.id != questionId) {
              m.disabledfirst = true;
            } else {
              m.disabledfirst = false;
            }
            this.$set(this.questionList, index, m);
          });
        } else {
          this.status = "2";
          this.selectDisable(false);
        }
      }
    })
    // 提交参数
    let answersLenth = this.addAnswers.length;
    // 提交参数长度小于0，则直接将选中的数据push到addAnswers
    // 大于0时，判断是否包含该数据，包含则修改，不包含则push,
    // 点击清空时将该条数据删除
    if(answersLenth > 0){
      // 用于记录此条数据没有在循环次数，循环结束，在addAnswers没有找到相应数据，则将该条数据push到addAnswers
      let len = 0;
      this.addAnswers.map((item: any, index: number) => {
        if (item.questionid == questionId) {
          item.option = optionId;
        } else {
          ++len;
        }
      });
    } else {
      let itemObj = {
        questionid: questionId,
        option: optionId
      }
      this.addAnswers.push(itemObj);
    }
    // 遍历每个问题是否已经选择，option 为手动选择，defalutOpt 为默认选择
    const optionArr = this.addAnswers
      .map((i: any) => ({
        option: i.option,
        defaultoption: i.defaultoption
      }))
      .filter((i: any) => (i.option || i.defaultoption)); // 其中一个不为 0 
    // 当前选线的item
    const currentOptionList = options.find(
      (item: any) => item.index === optionId
    );
    if (optionArr.length === 0) {
      // 没有选择任何一项
      this.dealDisabled = true;
      this.finishedDisabled = true;
    } else {
      // 选择其中一个
      this.dealDisabled = false; // 稍后处理可点
      if(!currentOptionList) {
        // 此时选择的是异常单选
        this.finishedDisabled = true;
      }
      else if (optionArr.length === answersLenth) {
        // 所有选择均已选择
        this.finishedDisabled = false;
      } else {
        // 是否为异常
        this.finishedDisabled =
          currentOptionList && currentOptionList.action === 1 ? true : false;
      }
    }
  }
  // 联系人跳转
  private navCustomer() {
    this.$router.push({
      path: "customerReviewInfo",
      query: {
        id: this.$route.query.customerid
      }
    });
  }
  //审核提交结果查询
  private async getRecord() {
    const { getPVRecord }: any = await import("@/request/examineDetail");
    let _arg = {
      ticketItemId: this.$route.query.ticketitemid,
      orderId: this.$route.query.orderid,
      ticketId: this.$route.query.ticketid
    }
    let res = await getPVRecord(
      _arg,
      this
    );
    if (res) {
      this.flagLoading=false//防止v-if闪现
      this.remark = res.remark;
      this.pvstatus = res.pvstatus;
      this.qistatus = res.qistatus;
      this.qlRemark = res.qiremark;
      res.pvstatus > 1 && this.selectDisable(true);
      if (this.pvstatus == 0) {
        this.isActived = "first";
      } else if (this.pvstatus == 1) {
        this.isActived = "second";
      } else if (this.pvstatus > 1) {
        this.isActived = "third";
      }
      let answersList =
        typeof res.answersList == "object"
          ? res.answersList
          : JSON.parse(res.answersList);
      if (answersList) {
        this.answersList = answersList;
        this.addAnswers = this.answersList;
          
        // 将数据返回对应到questionList，写入nxteleValue进行数据绑定
        this.questionList.map((item: any, index: number) => {
          this.addAnswers.map((m: any, mdex: number) => {
            if (item.id == m.questionid) {
              item.action = m.opaction;
              m.defaultoption = item.defaultoption; // 问题选择结果中增加默认选择结果
            }
            if (this.isActived == "third") {
              item.disabled = true;
              if (m.questionid == item.id) {
                if (this.nxteleValue[index] == "0") {
                  this.nxteleValue[index] = this.$tc("dashbordDy.nochoosed");
                } else {
                  this.nxteleValue[index] = m.option;
                }
                item.opvalue = m.opvalue;
                if (m.opaction == 3 || m.opaction == 2) {
                  item.opactionname = m.opactionname; //结果是失效和拒贷时显示结果，正常不展示
                }
                if (m.opaction == 0) {
                  item.opvalue = this.$tc("dashbordDy.nochoosed");
                }
                item.optionsList.map((o: any) => {
                  // 找到对应的action，进行下拉框禁用
                  if (m.option == o.index) {
                    // 如果存在需要禁用的
                    if (o.action == 3) {
                      this.status = "3";
                    }
                  }
                });
              }
            } else if (this.isActived == "second") {
              if (m.questionid == item.id) {
                if (this.nxteleValue[index] == "0") {
                  this.nxteleValue[index] = this.$tc("dashbordDy.nochoosed");
                } else {
                  if (m.option == 0) {
                    this.nxteleValue[index] = this.$tc("dashbordDy.nochoosed");
                  } else {
                    this.nxteleValue[index] = m.option;
                  }
                }
                item.opvalue = m.opvalue;
                if (m.opaction == 3 || m.opaction == 2) {
                  item.opactionname = m.opactionname; //结果是失效和拒贷时显示结果，正常不展示
                }

                item.optionsList.map((o: any) => {
                  // 找到对应的action，进行下拉框禁用
                  if (m.option == o.index) {
                    // 如果存在需要禁用的
                    if (o.action == 3) {
                      this.status = "3";
                      //  遍历questionList，找到该action=3的，将其他禁用
                      this.questionList.map((q: any) => {
                        if (m.questionid != q.id) {
                          q.disabledfirst = true;
                        } else {
                          q.disabledfirst = false;
                        }
                      });
                    }
                  }
                });
              }
            }
            if (this.itemId == "102") {
              item.disabled = true;
              if (m.questionid == item.id) {
                if (this.nxteleValue[index] == "0") {
                  this.nxteleValue[index] = this.$tc("dashbordDy.nochoosed");
                } else {
                  this.nxteleValue[index] = m.option;
                }
                item.opvalue = m.opvalue;
                if (m.opaction == 3 || m.opaction == 2) {
                  item.opactionname = m.opactionname; //结果是失效和拒贷时显示结果，正常不展示
                }
                if (m.opaction == 0) {
                  item.opvalue = this.$tc("dashbordDy.nochoosed");
                }
                item.optionsList.map((o: any) => {
                  // 找到对应的action，进行下拉框禁用
                  if (m.option == o.index) {
                    // 如果存在需要禁用的
                    if (o.action == 3) {
                      this.status = "3";
                    }
                  }
                });
              }
            }           
            if (!this.pvInfo && item.defaultoption!==0) {
              this.$set(this.nxteleValue, index, item.pvRadioValue)
            }
          });
        });
      }
    }
  }
  // 提交
  private saveSubmit(status?: string) {
    this.status = status ? status : this.status;
    localStorage.setItem("status", String(this.status));
    // this.status状态服务端不用，自己判断通过、失效、拒绝
    if (this.status == "1" || this.status == "3") {
      this.saveRecord(this.status);
    } else {
      let lenTest = 0;
      if (this.pvInfo) {//是否是选项分离
        this.questionList.forEach((it: any) => {
        this.addAnswers.forEach((e: any) => {
          // 大于0是预设
          if (it.pvRadioValue > 0 && this.pvInfo && e.option == 0 && it.id == e.questionid) {
            e.option = it.pvRadioValue;
          }
        });
      });
      }else{
        this.nxteleValue.forEach((o:any,p:any) => {
          this.addAnswers.forEach((e: any) => { 
            if (this.questionList[p].id==e.questionid && e.option == 0) {
              e.option = o
            }
          })
        });
      }
      
      this.addAnswers.forEach((item: any) => {
        if (item.option !== 0) {
          lenTest += 1;
        }
      });
      // 通过跟失效要校验问题必选
      localStorage.setItem("lenTest", String(lenTest));
      localStorage.setItem(
        "this.questionList",
        JSON.stringify(this.questionList)
      );
      localStorage.setItem(
        "this.questionList.length",
        String(this.questionList.length)
      );

      if (lenTest == this.questionList.length) {
        this.saveRecord(this.status + "");
      } else {
        this.$message.error("Please complete all reviews");
      }
    }
  }
  // 提交参数
  private recordFuc(status:string) {
    let _arg = {
      ticketItemId: this.$route.query.ticketitemid,
      orderId: this.$route.query.orderid,
      ticketId: this.$route.query.ticketid,
      status: this.status,
      addAnswers: this.addAnswers,
      remark: this.remark,
      appname: this.$route.query.appname,
    };
    return _arg;
  }
  // 审核提交
  private async saveRecord(status: string) {
    this.saveRecordLoading = true;
    const { savePVRecord }: any = await import("@/request/examineDetail");
    let res = await savePVRecord(this.recordFuc(status), this);
    if (res.commonout.code == 0) {
      this.saveRecordLoading = false;
      this.$message.success("success");
      if (res.nextpage.pb_switch && res.nextpage.pb_switch === 1) {
        if (res.nextpage.orderid !== "0") {
          this.$router.push({
            path: "/auditDetail",
            query: {
              orderid: res.nextpage.orderid,
              ticketitemid: res.nextpage.ticketitemid,
              customerid: res.nextpage.customerid,
              assignuid: res.nextpage.assignuid,
              ticketid: res.nextpage.ticketid,
              isAudi: this.isAudi,
              appname: res.nextpage.appname,
              status: res.nextpage.status,
            },
          });
          location.reload();
        } else {
          this.getRecord();
          setTimeout(() => {
            this.$message.warning(this.$tc("dashbordDy.notickets"));
          }, 3000);
        }
      } else {
        this.getRecord();
      }
    } else {
      this.saveRecordLoading = false;
    }
  }
  // 质检提交
  private async saveQiRecord(status: string) {
    this.saveQiRecordLoading = true;

    const { saveQIRecord }: any = await import("@/request/examineDetail");
    let _arg = {
      orderId: this.$route.query.orderid,
      ticketItemId: this.$route.query.ticketitemid,
      ticketId: this.$route.query.ticketid,
      qlRemark: this.qlRemark,
      qIstatus: status,
      appname: this.$route.query.appname,
    };
    let res = await saveQIRecord(_arg, this);
    if (res.commonout.code == 0) {
      this.saveQiRecordLoading = false;

      this.$message.success("success");
      if (res.nextpage.pb_switch && res.nextpage.pb_switch === 1) {
        if (res.nextpage.orderid !== "0") {
          this.$router.push({
            path: "/auditDetail",
            query: {
              orderid: res.nextpage.orderid,
              ticketitemid: res.nextpage.ticketitemid,
              customerid: res.nextpage.customerid,
              assignuid: res.nextpage.assignuid,
              ticketid: res.nextpage.ticketid,
              isAudi: this.isAudi,
              appname: res.nextpage.appname,
              status: res.nextpage.status,
            },
          });
          location.reload();
        } else {
          this.getRecord();
          setTimeout(() => {
            this.$message.warning(this.$tc("dashbordDy.notickets"));
          }, 3000);
        }
      } else {
        this.getRecord();
      }
    } else {
      this.saveQiRecordLoading = false;
    }
  }
  private questionData (data:any) {
    data.listList.map((item:any)=>{
      item.disabled = false;
      item.associateditemsList.map((m:any)=>{
        m.showBig = false;
        m.height = 100;
        m.rotate = 0;
      })
    })
    let phoneObject:any = [];
    data.phoneobjectMap.map((item:any)=>{
      let phoneItem:any = {};
      data.phoneobjectmobileMap.map((m:any)=>{
        if(item[0] == m[0]){
          phoneItem.value = item[0];
          phoneItem.label = item[1];
          phoneItem.phone = m[1];
          phoneObject.push(phoneItem);
        }
      })
    })
    data.phoneObject = phoneObject;
    return data;
  }
  // 审核问题
  private async getQuestion() {
    const { listVerifyQuestion }: any = await import(
      "@/request/examineDetail"
    );
    let _arg = {
      ticketItemId: this.$route.query.ticketitemid,
      orderId: this.$route.query.orderid,
      customerId: this.$route.query.customerid,
      ticketId: this.$route.query.ticketid,
      appname: this.$route.query.appname,
    };
    let res = await listVerifyQuestion(_arg, this);
    if (res) {
      let data = typeof res == "object" ? res : JSON.parse(res);
      //默认选项值
      let defalutOptionArr: Array<number> = [];
      // 暂存 qptype 值
      let qpTypeArr: Array<number> = [];
      data = this.questionData(data);
      // 电核拨打开关
      this.pvCallingSwitch = data.pvcallingswitch;
      // 是否显示选项按钮
      this.pvInfo = data?.optionradioswitch;
      //证件照来源
      this.idphotosourceswitch = data.idphotosourceswitch;
      this.isReloan = data.isreloan;
      // 审核问题
      this.questionList = data.listList.map((item: any) => {
        // 暂存预设选择
        defalutOptionArr.push(item.defaultoption);
        qpTypeArr.push(item.qptype)
        // 增加单选按钮
        const normalValue =
          item.optionsList &&
          item.optionsList.find((nL: any) => nL.action === 1);
        const radioListTemp = this.radioList.map((rL: any) =>
          Object.assign({}, rL, {
            value:
              rL.value === 1 && normalValue && normalValue.action === 1
                ? normalValue.index
                : rL.value,
          })
        );
        // 判断是否含有 2类问题，
        if(qpTypeArr.includes(3)) {
          this.isShowPhoneCon = true
        } else {
          this.isShowPhoneCon = false
        }

        return Object.assign({}, item, {
          // pvRadioValue: -1,
          pvRadioValue: item.defaultoption !== 0 ? radioListTemp[0].value : -1,
          radioList: radioListTemp,
        });
      });
      // 是否全为预设选择
      const defalutOptionArrRes = defalutOptionArr.filter((item: number) => item !== 0);
      if(defalutOptionArrRes.length !== 0) {
        // 表示存在预设选择
        this.dealDisabled = false;
        this.finishedDisabled = defalutOptionArrRes.length === this.questionList.length ? false : true;
      }

      // 电话对象
      this.phoneObject = data.phoneObject;
      //匹配供应商
      this.suppliertypeList = data.suppliertypeList;
      //盐值
      this.phoneobjectmobilesaltMap = data.phoneobjectmobilesaltMap;
      //拨打对象状态
      this.phonestatusMap = data.phonestatusMap;
      this.tickettags = data.tickettagsList;

      this.questionList.map((t: any, n: number) => {
        t.associateditemsList.map((p: any, o: number) => {
          this.phonestatusMap.map((item: any) => {
            if (item[0] == p.value) {
              t.associateditemsList[o].statusphone = item[1];
            }
          });
        });
      });

      this.matchProviderOptions();
      // 客户信息
      this.uesrInfo =  data.accountbase;
      if(this.uesrInfo.gender == -1){
        this.uesrInfo.gender = this.$tc('ticketLgy.Secrecy');
      } else if (this.uesrInfo.gender == 0){
        this.uesrInfo.gender = this.$tc('ticketLgy.Female');
      } else {
        this.uesrInfo.gender = this.$tc('ticketLgy.Male');
      }
      this.uesrInfo.dateofbirth =
        data?.customerinfo?.dateofbirth.replace(/\//g, "-") || null; // .replace(/\//g, '-')

      data.listList.forEach((item: any, index: any) => {
        item.associateditemsList.forEach((m: any, n: any) => {
          if (m.imagetype == 1 && m.value !== "<nil>") {
            this.idCardPhotoList.push(m);
          } else if (m.imagetype == 2 && m.value !== "<nil>") {
            this.livePhotoList.push(m);
          }
        });
      });
      this.getRecord();
    }
  }
  private dwMakeDialogFuc(
    phone: any,
    supplier: number,
    relation: number
  ) {
    return {
      assignuId: +this.$route.query.assignuid,
      phoneNumber: phone + "",
      supplier: supplier,
      orderId: this.$route.query.orderid,
      ticketType:  +this.$route.query.ticketitemid,
      ticketId: +this.$route.query.ticketid,
      opuId: Number(localGet("userid")),
      dialway: 0
    };
  }
  // 打電話 num, innerItem.id, item.relation
  private async makeDialog(
    phone: any,
    supplier: number,
    relation: number
  ) {
    this.formSaveCall.phoneTime = new Date();
    if(!phone) {
      // 请选择拨打对象
      let msg:any = this.$t('tipsLgy.SelectPerson');
      this.$message.error(msg);
      return;
    };
    const { makeDial }: any = await import("@/request/makeDial");
    let res = await makeDial(
      this.dwMakeDialogFuc(phone, supplier, relation),
      this
    );
    if (res) {
      this.$emit("makeDialogueResult", {
        //  取本地返回的关系列表 2020-0819 hom
        // resCallObj: res.objectoptionsList, // 关系
        dialId: res.dialid
      });
      if(res.commonout.code == 0){
        this.formSaveCall.callId = res.dialid;
      }
    }
  }
  private saveCallLogFuc(){
    return {
      ticketId: this.$route.query.ticketid,
      orderId: this.$route.query.orderid,
      phoneConnected: this.formSaveCall.phoneConnected,
      phoneObject: this.formSaveCall.phoneObject[0],
      phoneCallInput: this.formSaveCall.phoneCallInput,
      phoneTime: timeFormat(this.formSaveCall.phoneTime),
      callId: this.formSaveCall.callId,
      ticketItemId: this.$route.query.ticketitemid
    };
  }
  // 保存通话记录
  private async saveCallLog(){
    if(!this.formSaveCall.phoneTime){
      // 请选择拨打时间
      let msg:any = this.$t('tipsLgy.SelectCallTime');
      this.$message.error(msg);
      return;
    } else if(!this.formSaveCall.phoneObject){
      // 请选择拨打对象
      let msg:any = this.$t('tipsLgy.SelectPerson');
      this.$message.error(msg);
      return;
    } else if(!this.formSaveCall.phoneConnected){
      // 请选择是否接通
      let msg:any = this.$t('tipsLgy.SelectWhetherConnect');
      this.$message.error(msg);
      return;
    }
    const { saveCall }: any = await import("@/request/examineDetail");
    let res = await saveCall(
      this.saveCallLogFuc(),
      this
    );
    if (res) {
      if(res.commonout.code == 0){
        this.formSaveCall.phoneTime = "";
        this.formSaveCall.phoneConnected = "";
        this.formSaveCall.phoneObject = "";
        this.formSaveCall.phoneCallInput = "";
        this.formSaveCall.callId = "";
        this.$message.success(res.opmessage);
      }
    }
  }
}
